import { createAction, props } from '@ngrx/store';
import { CartConfig } from '@shared/models/cart-config';

export const setCartConfig = createAction(
  '[Cart] Set Cart Config',
  props<{ cartConfig: CartConfig; clearCart: boolean }>(),
);
